import * as THREE from "three";
import { EXTERIOR_WORLD, PLACES, FINDS } from "@catworld/shared";
import { MATS } from "../materials.js";
import { CAR, CAR_TIERS } from "../spec.js";
import { makeRng } from "../builder.js";
import { burrBush } from "../greenspace.js";
import { exteriorGroundY } from "./ground.js";

/** The gameplay half of the exported world; safe under browser and Node.
 * @param {import('../builder.js').Builder} b */
export function build(b) {
  b.setGrade(null);
  for (const data of EXTERIOR_WORLD.colliders) {
    const box = new THREE.Box3(new THREE.Vector3().fromArray(data.min),
      new THREE.Vector3().fromArray(data.max));
    b.tag(b.push(box), data.climb);
  }
  // Car visuals already share these dimensions with their procedural loader.
  for (const t of CAR_TIERS) {
    b.collider(CAR.x, CAR.y, CAR.z + (t.z0 + t.z1) / 2,
      t.w, t.top, t.z1 - t.z0, false);
  }
  b.mark("spawn", EXTERIOR_WORLD.spawn.x, EXTERIOR_WORLD.spawn.y, EXTERIOR_WORLD.spawn.z);
  for (const p of PLACES) b.mark(p.id, p.x, p.y, p.z);
  for (const f of FINDS) b.mark("find:" + f.id, f.x, f.y, f.z);

  // Outdoor props omitted from the architectural study: bins and burrs.
  // Keep lids against the house so the navigation lane at x=5.8 also fits
  // the cat's body. The previous placement let point paths graze the bins.
  for (const z of [-7, -7.7]) {
    b.block(5.35, 0.005, z, 0.46, 0.83, 0.48, MATS.plasticGreen);
    b.block(5.35, 0.835, z, 0.5, 0.06, 0.52, MATS.plasticGreen);
  }
  const burrs = /** @type {[number, number, string][]} */ ([
    [-4.55, -28.5, "shed-corner"], [-8.4, -35.0, "woodland-west"],
    [9.3, -46.5, "creek-east"],
  ]);
  for (const [x, z, name] of burrs) {
    b.setGrade(exteriorGroundY);
    burrBush(b, makeRng(0x1313 + name.length), x, z, name);
  }
  b.setGrade(null);
  // Contain play at the visible site's outer edge.
  const q = EXTERIOR_WORLD.bounds;
  b.setOwner("exterior/boundary");
  for (const x of [q.minX, q.maxX]) b.collider(x, -3, (q.minZ + q.maxZ) / 2, .18, 18, q.maxZ - q.minZ, false);
  for (const z of [q.minZ, q.maxZ]) b.collider((q.minX + q.maxX) / 2, -3, z, q.maxX - q.minX, 18, .18, false);
}
